import { FieldErrors, FieldValues } from 'react-hook-form'
import get from 'lodash/get'
import has from 'lodash/has'
import isArray from 'lodash/isArray'
import some from 'lodash/some'

export const getIsErrorTab = <T extends FieldValues>(
  errors: FieldErrors<T>,
  keys: string[] | string
) => {
  if (isArray(keys)) {
    return some(keys, item => has(errors, item)) ? 'error' : undefined
  }

  return get(errors, keys) && 'error'
}
